import styled from 'styled-components';

export const Container = styled.div`

    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    align-items: center;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // -user-select: none;
    -webkit-tap-highlight-color: transparent;

        p {
            margin: 0
        }

        .div-pai { 
            margin: 32px;
            background-color: #fff;
            max-width: 1096px;
            min-width: 300px;
            width: 88%;
            padding-bottom: 80px;
            border-radius: 8px;

            @media (max-width: 1330px) {
                margin-bottom: 80px;
                padding-right: 90px;
                padding-left: 90px;
            }

            @media (max-width: 690px) {
                margin-top: 161px;
                height: fit-content; 
                padding-right: 0px;  
                padding-left: 0px;
            }

            @media(max-width: 360px) {
                margin: 24px;
                margin-top: 153px;
                margin-bottom: 80px;
                height: fit-content;
                padding-right: 0px;
                padding-left: 0px;
            }

        

            .div-rota {
                margin-right: 16px;
                margin-top: 40px;
                margin-left: 32px;
                width: 90%;
                overflow: hidden;
                white-space:nowrap;
                text-overflow: ellipsis;

                @media(max-width: 360px) {
                    margin-left: 16px
                }
            
            span {
                font-family: Montserrat;
                font-size: 14px;
                color: #2a0709;
                font-weight: 500;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }

            .rotas {
                font-family: Montserrat;
                font-size: 14px;
                color: #a49b9b;
                font-weight: normal;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }
        }

        .emoji {
            width: 32px;
            height: 32px;
            margin-top: 40px;
            margin-left: 32px;
            margin-bottom: 24px;
            object-fit: contain;

            @media(max-width: 690px) {
                    margin-left: 16px;
                    margin-top: 32px
                }
        }

        h1 {
            font-family: Montserrat;
            font-size: 32px;
            margin-top: 0;
            margin-left: 32px;
            margin-right: 16px;
            margin-bottom: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 690px) {
                margin-left: 16px;
                font-size: 24px;
            }
        }

        h5 {
            margin-top: 24px;
            margin-left: 32px;
            margin-right: 56px;
            margin-bottom: 40px;           
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 690px) {
                margin-left: 16px;
                margin-right: 19px;
                font-family: Montserrat;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 24px;
            }
        }

        hr {
            display: block; 
            height: 1px;
            border: 0; 
            border-top: 2px solid #f3f3f3;
            margin: 1em 0; 
            padding: 0;
        }

        .linha {
            width: 95%;
            border-top: 2px solid #f3f3f3;
            margin: auto;
            margin: 64px 32px;

            @media(max-width: 691px) {
                margin: 56px 0px;
            }   
        }
            
        h3 {
            margin-top: 64px;
            margin-bottom: 40px;
            margin-left: 32px;
            font-family: Montserrat;
            font-size: 24px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 690px) {
                margin-left: 16px;
                margin-top: 20px; 
                font-size: 16px;
                line-height: 32px;
                margin-bottom: 40px;
            }
        }

        .star{
            width: 24px;
            height: 24px;
            display: flex;
            margin-right: 16px;
            padding-top: 20px;
            padding-bottom: 20px;

            @media(max-width: 690px) {
                width: 14px;
                height: 14px;
                padding-top: 8px;
                padding-bottom: 0px;
            }    
        }

        .star1{
            display: flex;
            flex-direction: row;
        }

        .nota{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 32px;
            line-height: 32px;
            color: #2D2D2D;

            @media(max-width: 690px){
                font-size: 24px;
                line-height: 24px;
            }
        }

        .descricao{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: #2D2D2D;
            margin-top: 25px;
            margin-bottom: 40px;

            @media(max-width: 690px){
                font-size: 14px;
                padding-top: 0px;
                padding-right: 0px;
            }
        }

        .borda{
            // box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding: 40px 32px;
            gap: 12px;
            position: relative;
            width: 488px;
            height: 200px;
            margin-left: 32px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 8px;
            padding-bottom: 0px;

            @media(max-width: 900px){
                position: relative;
                width: auto;
                height: auto;
                margin-left: 16px;
                // margin-right: 16px;
                padding-top: 24px;
                padding-left: 18px;
                padding-right: 0px;
                margin-bottom: 12px;
                padding-bottom: 20px;
            }
        }

        .borda2{
            // box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding: 40px 32px;
            gap: 12px;
            position: relative;
            width: 256px;
            height: 200px;
            margin-left: 15px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 8px;
            padding-bottom: 0px;

            @media(max-width: 900px){
                width: auto;
                height: 144px;
                // margin-left: 16px;
                // margin-right: 16px;
                padding-top: 24px;
                padding-left: 18px;
                padding-right: 0px;
                margin-bottom: 12px;
                padding-bottom: 40px;
            }
        }

        .borda3{
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 40px 24px;
            margin-right: 24px;
            gap: 24px;
            position: relative;
            width: auto;
            left: 24px;
            top: 24px;
            margin-bottom: 24px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 16px;

            @media(max-width: 360px){
                width: auto;
                height: 136px;
                left: 16px;
                margin-right: 16px;
                padding: 24px;
                margin-bottom: 16px;
                }
            }

        .borda4{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            padding: 16px;
            gap: 4px;
            width: 945px;
            height: 48px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 8px;
            margin-top: 8px;

            @media(max-width: 690px){
                width: auto;
                height: auto;
                margin-right: 16px;
            }
        }

        .borda5{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 40px 24px;
            gap: 24px;
            position: relative;
            width: 980px;
            height: 260px;
            background: #FFFFFF;
            border: 1px solid #EEEEEE;
            border-radius: 16px;
            left: 32px;
            top: 24px;

            @media(max-width: 690px){
                width: auto;
                height: auto;
                left: 16px;
                margin-right: 16px;
                padding: 24px;
                margin-bottom: 60px;
                padding-right: 0px;
                }
        }

        .borderPink{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 24px;
            gap: 4px;
            background: #FFF9E9;
            border-radius: 8px;
            margin-left: 32px;
            margin-right: 32px;

            @media(max-width: 690px){
                margin-left: 16px;
                margin-right: 0px;
                width: auto;
                padding: 30px;
            }
        }

        .row1{
            display: flex;

            @media(max-width: 690px){
            flex-direction: column;
            }

            @media(max-width: 900px){
                flex-direction: column;
                }
        }


        .row-mobile{
            display: flex;
            @media(max-width: 690px){

            }
        }

        .icone{
            width: 24px;
            height: 24px;
            margin-right: 10px;
            margin-top: 20px;

            @media(max-width: 690px){
                width: 16px;
                height: 16px;
                margin-top: 27px;
            }
        }

        .conteudo{
            display: flex;
        }

        .hand{
            width: 16px;
            height: 16px;
            line-height: 16px;
            margin-right: 8px;
        }

        .coments{
            width: 984px;
            height: 40px;   
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #2D2D2D;

            @media(max-width: 690px){
                width: 232px;
                height: 144px;
                line-height: 24px;
            }
        }

        .paginas{
            font-style: normal;
            font-family: Montserrat;
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            color: #000000; 
          
            @media(max-width: 690px){
                font-size: 12px;
            }

        }

        .paginas1{ 
            font-style: normal;
            font-family: Montserrat;
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            color: #000000; 
            margin-right: 27px;
            width: 40px;
            height: 40px;
            border-radius: 4px;
            background-color: #FBFAFA;
            border: #FBFAFA;
          
            
            @media(max-width: 690px){
                font-size: 12px;
                margin-right: 14px;
            }

            :hover {
                background-color: #FBFAFA;
            }
        }

        .paginaEnd{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            padding: 12px;
            color: #D7232C;
            
            @media(max-width: 690px){
                font-size: 12px;
            }
        }

        .paginacao{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            color: #000000;
            margin-left: 32px;
            margin-top: 40px;

            @media(max-width: 690px){
                font-size: 12px;
                margin-left: 16px;
            }
        }

        .paginacaoEnd{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            color: #000000;
            margin-top: 40px;
            margin-left: 435px;
            padding-top: 64px;
            position: relative;

            @media(max-width: 960px){
                font-size: 12px;
                margin-left: 134px;
            }

            @media(max-width: 360px){
                font-size: 12px;
                margin-left: 20px;
            }
        }

        .user{
            width: 40px;
            height: 40px; 
            padding-right: 12px;
        }

        .userName{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 16px;
            color: #2D2D2D;
        }

        .subtexto{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            color: #2D2D2D;
            display: flex;
            margin-top: 8px;
        }

        .subtexto1{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #2D2D2D;
            display: flex;
            margin-right: 16px;
            margin-top: 8px;

            @media(max-width: 690px){
                margin-top: 2px;
            }
        }

        .sub_icone{
            width: 24px;
            height: 24px;
            line-height: 16px;
            margin-right: 8px;
            margin-bottom: 28px;

            @media(max-width: 690px){
                width: 16px;
                height: 16px;
            }
        }

        .star_coments{
            width: 14px;
            height: 14px;
            margin-right: 10px;
            margin-top: 8px;

            @media(max-width: 690px){
                margin-top: 2px;
            }
        }

        .comentario{
            width: 74px;
            height: 16px;
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #6F6565;
            padding-top: 28px;

            @media(max-width: 690px){
                margin-top: 24px;
                margin-bottom: 8px;
            }
        }

        .setaPage{
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding: 0px;
            gap: 8px;
            position: relative;
            width: 196px;
            height: 40px;
            left: 459px;
            bottom: 96px;
            top: 88px;   
        }

        .textonull{
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 32px;
            color: #2D2D2D;
            margin-left: 32px;
            margin-top: 40px;

            @media(max-width: 690px){
                font-size: 16px;
                line-height: 24px;
                margin-left: 16px;
                margin-bottom: 48px;
                padding-right: 40px;
            }
        }

        .aval-mobile{
            margin-top: 64px;
            margin-bottom: 40px;
            margin-left: 32px;
            font-family: Montserrat;
            font-size: 24px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 690px){
                font-size: 20px;
                line-height: 24px;
                margin-top: 48px;
                margin-bottom: 24px;
                margin-left: 16px;
            }
        }

        .posicao{
            margin-right: 16px;
        }

        .button{
            outline: none;
            border: none;
            background-color: #fff;
            color: #D7232C;
            font-weight: 600;
            margin-right: 36px;   
            
            @media(max-width: 690px){
                margin-right: 14px;
            }
        }

        .button1{
            outline: none;
            border: none;
            background-color: #fff;
            color: #D7232C;
            font-weight: 600;
            margin-right: 10px;
        }

        .arrow{
            margin-right: 10px;
            margin-left: 10px;
        }

        .bold{
            font-weight: bold;
        }

    }

`